import { getDataFromServer } from "../util";

// ações sobre o usuário
export const changeAgentAction = async (body) => getDataFromServer("PATCH", `management/actions/change-agent`, body, true);
export const promoteToAgentAction = async (body) => getDataFromServer("PATCH", `management/actions/promote-to-agent`, body, true);
export const demoteFromAgentAction = async (body) => getDataFromServer("PATCH", `management/actions/demote-from-agent`, body, true);
export const clearAgentAction = async (body) => getDataFromServer("PATCH", `management/actions/clear-agent`, body, true);
export const archiveUserAction = async (body) => getDataFromServer("PATCH", `management/actions/archive-user`, body, true);
export const changeRecommender = async (id, data) =>
  getDataFromServer(
    "PATCH",
    `management/actions/edit-recommender`,
    {
      editedUserId: id,
      recommenderId: data.recommenderId,
      recommenderPercent: data.recommenderPercent,
    },
    true,
  );

export const removeRecommender = async (id) =>
  getDataFromServer(
    "PATCH",
    `management/actions/clear-recommender`,
    {
      editedUserId: id,
    },
    true,
  );

//ações de edição do agreement de um agente 
export const resetAgreementStatusAction = async (body) => getDataFromServer("PATCH", `management/actions/agreement/reset-status`, body, true);
export const editAgreementClass = async (body) => getDataFromServer("PATCH", `management/actions/agreement/class`, body, true);
export const editAgreementJobTitle = async (body) => getDataFromServer("PATCH", `management/actions/agreement/job-title`, body, true);
export const editAgreementManagerMonthlyCommission = async (body) => getDataFromServer("PATCH", `management/actions/agreement/manager-monthly-commission`, body, true);
export const editAgreementManagerOneTimeCommission = async (body) => getDataFromServer("PATCH", `management/actions/agreement/manager-one-time-commission`, body, true);
export const editAgreementCommissionLimit = async (body) => getDataFromServer("PATCH", `management/actions/agreement/commission-limit`, body, true);
export const editAgreementInvestment = async (body) => getDataFromServer("PATCH", `management/actions/agreement/investment`, body, true);
export const editAgreementVisibility = async (body) => getDataFromServer("PATCH", `management/actions/agreement/visibility`, body, true);
export const editAgreementPermissions = async (body) => getDataFromServer("PATCH", `management/actions/agreement/permissions`, body, true);
